import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';

 

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(private router:Router) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(catchError(err => {
            if (err.status === 503) {
                // auto logout if 401 response returned from api
             
                location.reload(true);
                this.router.navigate(['/maintenance'])

            }
            else if(err.status == 401)
            {
                localStorage.removeItem('currentSubSationalUser')
                localStorage.removeItem('currentSubSationalUserId')
                this.router.navigate(['/'])
            }
            
            const error = err.error ? (err.error.message || err.statusText) : JSON.stringify(err) ;
            return throwError(error);
        }))
    }
}